import type { ZodError, ZodSchema } from 'zod';

export type ValidationResult<T> = { success: true; data: T } | { success: false; error: ReturnType<ZodError<T>['format']> };

export function validate<T>(schema: ZodSchema<T>, data: unknown): ValidationResult<T> {
  const result = schema.safeParse(data);
  if (result.success) {
    return { success: true, data: result.data };
  }
  return { success: false, error: result.error.format() };
}
